module.exports = __webpack_public_path__ + "img/pos1-bg.ed405d84.jpg";